export default __webpack_public_path__ + "static/escaperoomer-e5e15461848968159f662e452713daa0.png";